module.exports = __webpack_public_path__ + "static/media/individual_02.4bde5901.jpg";